import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, map, mergeMap, shareReplay } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ApplicationUser } from 'src/app/models/application-user/application-user';
import { AlertService } from 'src/app/services/alert.service';
import { ApplicationUserService } from '../services/application-user.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    constructor(private alert: AlertService , private service: ApplicationUserService, private router: Router) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
        return next.handle(request).pipe(catchError((err: HttpErrorResponse) => {
            const skipGlobalErrorHandler = request.headers.has('X-Skip-Global-Error-Handler');

            switch(err.status){
                case 403:
                    if (!skipGlobalErrorHandler)
                        this.alert.showError('Bu iÅŸlemi yapmak iÃ§in yetkiniz yok.');
                    break;
                case 400:
                    if (!skipGlobalErrorHandler) {
                        if (err.error.isNeedConfirm)
                            return throwError(err);
                        else{
                            if (this.sessionNeedEnd(err.error.errorMessage)){
                                this.service.logout();
                                this.router.navigate(['/login']);
                            }
                            else{
                                this.alert.showValidation(err.error.errorMessage);
                            }
                        }
                    }
                    break;
                case 404:
                    if (!skipGlobalErrorHandler)
                        this.alert.showError(err.error);
                    break;
                case 406: {
                    // İstek gönderildikten sonra token başka bir istek tarafından zaten yenilendiyse
                    // yeniden yenileme yapılmaz, istek güncel token'la tekrarlanır.
                    const currentToken = this.service.currentUserValue?.token;
                    if (currentToken && request.headers.get('authToken') !== currentToken)
                        return next.handle(this.withToken(request, currentToken));

                    return this.refreshAccessToken().pipe(
                        mergeMap(token => token
                            ? next.handle(this.withToken(request, token))
                            : throwError('Oturum yenilenemedi.'))
                    );
                }
                case 500:
                    if (!skipGlobalErrorHandler)
                        this.alert.showError(err.error.message);
                    break;
            }

            if (err.error.data != null)
                return throwError(err.error);

            const error = err.error.message || err.error.errorMessage || err.message;
            return throwError(error);
        }));
    }

    /**
     * Süren token yenilemesi. Backend her yenilemede eski yenileme token'ını geçersiz kılar; aynı
     * anda 406 alan istekler (ör. birden çok liste ve KPI'sı olan bir sayfa) ayrı ayrı yenileme
     * yaparsa ilki dışındakiler "sessionNeedEnd" alır ve oturum kapanırdı. Bu yüzden eş zamanlı
     * 406'lar tek yenilemeyi paylaşır.
     */
    private refreshInProgress$: Observable<string | null> | null = null;

    private refreshAccessToken(): Observable<string | null> {
        if (!this.refreshInProgress$) {
            this.refreshInProgress$ = this.service.refreshToken(this.service.currentUserValue?.refreshToken).pipe(
                map(res => {
                    if (!res?.data)
                        return null;
                    const user: ApplicationUser = JSON.parse(localStorage.getItem('currentUser'));
                    user.token = res.data.accessToken;
                    user.refreshToken = res.data.refreshToken;
                    localStorage.setItem('currentUser', JSON.stringify(user));
                    this.service.currentUserSubject.next(user);
                    return res.data.accessToken;
                }),
                finalize(() => this.refreshInProgress$ = null),
                shareReplay(1)
            );
        }
        return this.refreshInProgress$;
    }

    private withToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
        let headers = request.headers.set('authToken', token);
        if (request.headers.has('Authorization'))
            headers = headers.set('Authorization', 'Bearer ' + token);
        return request.clone({ headers });
    }

    sessionNeedEnd(message: any): boolean{
        for (var k in message){
            if (message.hasOwnProperty(k)) {
                if(k && k == 'sessionNeedEnd')
                    return true;
                else
                    return false;
            }
        }
    }
}
